import React, { useState, useEffect, useCallback, useRef } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import useAppContext from "../../../utils/Reducers";
import ButtonBar from "../../../components/Layout/ButtonBar";
import SearchBar from "./SearchBar";
import { useAxiosWithAuthorization } from "../../../utils/api";
import { ModalConfirm } from "../../../components/Confirm";
import { columnLayout } from "./columnLayout";
import { defaultGridProps } from "../../../components/AuiGrid/gridLayout";
import {
  setStorageItem,
  getStorageItem,
} from "../../../hooks/Storage/useLocalStorage";
import moment from "moment";
import AUIGrid from "../../../lib/AuiGrid/AUIGridReact";
import { ModalDepartureImagePop } from "../../Popup/DepartureImagePop";
import { ModalIncomeCallPop } from "../../Popup/IncomeCallPop";
import { useInterval } from "../../../utils/validators";

//전송버튼을 클릭했을경우 함수가 외부에서 호출하여 primaryParameters 아무값도 들어가 있지 않음
//그래서 플래그를 두어 sendCnt값이 변경되면 useEffect에서 검색버튼의 함수를 실행시킴
var sendCnt = 0;

const IncomingVehicleMng = (props) => {
  const myGrid = useRef();
  const [research, setResearch] = useState(0);

  const {
    store: { userInfo, menuKey },
  } = useAppContext();

  useEffect(() => {
    const auiGrid = myGrid.current;
    auiGrid.resize("100%", 600);
  }, [menuKey]);

  const [searchParameters, setSearchParameters] = useState({
    schPlantCd: userInfo.defaultPlantNo,
    schSearch: "",
    schTransStatusCd: "",
    schSwghtDt: moment().format("YYYY-MM-DD"),
    schEwghtDt: moment().format("YYYY-MM-DD"),
  });

  const initItem = {
    realWeight: "",
    statusD: "",
    statusI: "",
    statusS: "",
    statusT: "",
    statusTotal: "",
    statusW: "",
  };

  const [fieldValues, setFieldValues] = useState(initItem);

  const SEARCH_INCOMING_VEHICLELIST_URL =
    "/incoming/incomingvehicle/searchIncomingVehicleList.do";

  //배차정보 저장 URL
  const CHANGE_TRANSO_STATUS_URL =
    "/domesticscrap/inspectionwait/changeTransStatus.do";

  //배차정보 저장 URL
  //const MESSAGE_TRANSORDER_URL = "http://tms.idaehan.com:8080/message/sendTransCallInMessage.do";
  const MESSAGE_TRANSORDER_URL =
    "https://tms.idaehan.com:8443/message/sendTransCallInMessage.do";

  //배차취소 URL
  const MESSAGE_CALLCANCEL_URL =
    "https://tms.idaehan.com:8443/message/sendTransCallCancelMessage.do";

  //오늘 하루 통합 운송량 검색 URL
  const SERARCH_TRANSTOTALCOUNT_URL =
    "/domesticscrap/inspectionwait/searchTransTotalCount.do";

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SEARCH_INCOMING_VEHICLELIST_URL,
    },
    { manual: true }
  );

  //코드 및 그리드 초기화 및 생성
  useEffect(() => {
    if (research !== 0) {
      handleMasterSearch();
    }
  }, [research]);

  const popDepartureImage = (event) => {
    //console.log(event.item);
    ModalDepartureImagePop({ tmsOdrNo: event.item.tmsOdrNo, type: "image" });
  };

  const onIncomeCallIn = (schPlantCd) => {
    ModalIncomeCallPop({
      title: "입차호출",
      schPlantCd: schPlantCd,
      onSelectPlant: onSelectPlant,
    });
  };

  useEffect(() => {
    const auiGrid = myGrid.current;

    //Local Storage에 저장된 그리드 컬럼 정렬정보를 가져옴
    const columnList = getStorageItem(props.menuInfo.menuId, "");
    if (columnList !== "") {
      auiGrid.setColumnOrder(columnList);
    }
    const columnSize = getStorageItem(props.menuInfo.menuId + "_s", "");
    if (columnSize !== "") {
      //Local Storage에 저장된 그리드 컬럼 Width 정보를 가져옴
      auiGrid.setColumnSizeList(columnSize);
    }
    searchTransTotalCount();
  }, []);

  useInterval(() => {
    searchTransTotalCount();
  }, 60000);

  const searchTransTotalCount = async () => {
    const {
      data: { data },
    } = await fetchData({
      url: SERARCH_TRANSTOTALCOUNT_URL,
    });

    //console.log(data);

    setFieldValues(data[0]);
  };

  //팝업 데이터 가져오기
  const onSelectPlant = useCallback(async (values) => {
    const auiGrid = myGrid.current;
    const items = auiGrid.getSelectedItems()[0];

    //console.log(values);
    //console.log(items);

    var transStatusCd = "";
    if (items.item.transStatusCd !== "N") {
      transStatusCd = "G";
    } else {
      transStatusCd = "I";
    }

    const {
      data: { statusCode },
    } = await axios({
      method: "POST",
      url: MESSAGE_TRANSORDER_URL,
      data: {
        tmsOdrNo: items.item.tmsOdrNo,
        vhclNo: items.item.vhclNo,
        drivTel: items.item.drivTel,
        transStatusCd: transStatusCd,
      },
    }).catch(function (error) {
      if (error.response) {
        // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
        //console.log(error.response.data);
        //console.log(error.response.status);
        //console.log(error.response.headers);
        toast.error(
          "카카오톡 전송 오류 : " + error.response.data.error.message
        );
      } else if (error.request) {
        // 요청이 이루어 졌으나 응답을 받지 못했습니다.
        // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
        // Node.js의 http.ClientRequest 인스턴스입니다.
        //console.log(error.request);
      } else {
        // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
        //console.log("Error", error.message);
      }
      //console.log(error.config);
    });

    if (statusCode === "200") {
      const {
        data: { data },
      } = await fetchData({
        url: CHANGE_TRANSO_STATUS_URL,
        data: {
          systemCd: items.item.systemCd,
          scrapAreaCd: values.scrapAreaCd,
          tmsOdrNo: items.item.tmsOdrNo,
          transStatusCd: transStatusCd,
        },
        method: "POST",
      });

      sendCnt = sendCnt + 1;
      //console.log(sendCnt);
      setResearch(sendCnt);
    } else {
      ModalConfirm({
        title: "입차호출 에러",
        description:
          "입차호출 에러로 다시 입차호출버튼을 클릭해주시기 바랍니다.  ",
        type: "alert",
      });
    }
  });

  //메시지 전송을 하고 나서 배송상태값을 입차호출 T 로 변경
  const onIncomeButtonClick = useCallback(async (event) => {
    if (event.item.transStatusCd === "A") {
      if (event.item.tmsOdrNo !== "") {
        //console.log(event.item.plantCd);
        //배차종류가 이송이고 배차상태가 'N'이면 도착지 플랜트를 전송해야한다.
        if (event.item.transStatusCd !== "N") {
          onIncomeCallIn(event.item.plantCd);
        } else {
          onIncomeCallIn(event.item.poaPlantCd);
        }
      }
    } else if (event.item.transStatusCd === "G") {
      if (event.item.tmsOdrNo !== "") {
        if (
          await ModalConfirm({
            title: "입차취소",
            description:
              event.item.vhclNo + "차량의 입차호출을 취소하겠습니까?",
          })
        ) {
          const {
            data: { statusCode },
          } = await axios({
            method: "POST",
            url: MESSAGE_CALLCANCEL_URL,
            data: {
              tmsOdrNo: event.item.tmsOdrNo,
              vhclNo: event.item.vhclNo,
              drivTel: event.item.drivTel,
              transStatusCd: "B",
            },
          }).catch(function (error) {
            if (error.response) {
              // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
              //console.log(error.response.data);
              //console.log(error.response.status);
              //console.log(error.response.headers);
              toast.error(
                "카카오톡 전송 오류 : " + error.response.data.error.message
              );
            } else if (error.request) {
              // 요청이 이루어 졌으나 응답을 받지 못했습니다.
              // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
              // Node.js의 http.ClientRequest 인스턴스입니다.
              //console.log(error.request);
            } else {
              // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
              //console.log("Error", error.message);
            }
            //console.log(error.config);
          });

          if (statusCode === "200") {
            const {
              data: { data },
            } = await fetchData({
              url: CHANGE_TRANSO_STATUS_URL,
              data: {
                systemCd: event.item.systemCd,
                scrapAreaCd: "",
                tmsOdrNo: event.item.tmsOdrNo,
                transStatusCd: "A",
              },
              method: "POST",
            });

            sendCnt = sendCnt + 1;
            //console.log(sendCnt);
            setResearch(sendCnt);
          }
        }
      }
    }
  });

  //그리드 정렬 저장
  const handleGridSorting = useCallback(() => {
    const auiGrid = myGrid.current;
    const items = auiGrid.getColumnInfoList();
    let columnList = [];
    let columnSize = [];
    items.forEach((item) => {
      columnList.push(item.dataField);
      columnSize.push(item.width);
    });
    //console.log(items);
    setStorageItem(props.menuInfo.menuId, columnList);
    setStorageItem(props.menuInfo.menuId + "_s", columnSize);
    ModalConfirm({
      title: "그리드 정렬 저장",
      description: "그리드 정렬을 저장하였습니다. ",
    });
  });

  const handleMasterExcel = useCallback(() => {
    const auiGrid = myGrid.current;
    auiGrid.exportToXlsx({
      fileName: props.menuInfo.menuNmKor + " 리스트",
      exceptColumnFields: auiGrid.getHiddenColumnDataFields(),
    });
  });

  const handleMasterSearch = async () => {
    const auiGrid = myGrid.current;
    auiGrid.showAjaxLoader();
    const {
      data: { data },
    } = await fetchData({
      url: SEARCH_INCOMING_VEHICLELIST_URL,
      params: searchParameters,
    });
    auiGrid.setGridData(data);
    auiGrid.removeAjaxLoader();
  };

  //그리드 정렬 취소
  const handleGridSortingCancel = useCallback(() => {
    const auiGrid = myGrid.current;
    setStorageItem(props.menuInfo.menuId, "");
    var colLayout = columnLayout(onIncomeButtonClick, popDepartureImage);
    auiGrid.changeColumnLayout(colLayout);
    ModalConfirm({
      title: "그리드 정렬 취소",
      description: "그리드 정렬을 취소하였습니다. ",
    });
  });

  return (
    <>
      <ButtonBar
        menuInfo={props.menuInfo}
        handleMasterSearch={handleMasterSearch}
        handleMasterExcel={handleMasterExcel}
        isGridSort={true}
        handleGridSorting={handleGridSorting}
        handleGridSortingCancel={handleGridSortingCancel}
      />
      <SearchBar
        setSearchParameters={setSearchParameters}
        searchParameters={searchParameters}
      />

      <AUIGrid
        ref={myGrid}
        columnLayout={columnLayout(onIncomeButtonClick, popDepartureImage)}
        gridProps={{ ...defaultGridProps, width: "100%", height: 600 }}
      />
    </>
  );
};

export default IncomingVehicleMng;
